export default "__VITE_ASSET__a6731e56__"